import { render, staticRenderFns } from "./picUpload.vue?vue&type=template&id=491fb84a&scoped=true&"
import script from "./picUpload.vue?vue&type=script&lang=js&"
export * from "./picUpload.vue?vue&type=script&lang=js&"
import style0 from "./picUpload.vue?vue&type=style&index=0&id=491fb84a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491fb84a",
  null
  
)

export default component.exports